module.exports = __webpack_public_path__ + "static/media/Papel.818f6df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Papel.png
// module id = 181
// module chunks = 0